import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { tokensPath } from '../../cross-team-shared/hub-paths';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';
import {
  TokenResponse,
  TokenScope,
} from '../../team-apis/otterdam/token-typings';

@Injectable({ providedIn: 'root' })
export class TokenResource extends UrlRequestService {
  getToken(scope: TokenScope, accessToken: string): Promise<TokenResponse> {
    return this.request<TokenResponse>(
      'POST',
      `${environment.sh3BaseUrl}${tokensPath()}`,
      {
        body: { scope },
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    );
  }
}
